import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

const Dashboard = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <nav aria-label="breadcrumb" className="mb-4">
        <ol className="breadcrumb">
          <li className="breadcrumb-item active" aria-current="page">Dashboard</li>
        </ol>
      </nav> */}

      <PageHeader
        eyebrow="Customer Service Portal"
        title="Dashboard"
        description="Manage customer onboarding, billing flows, and service operations."
        icon="house"
        iconTone="primary"
        className="mb-4"
      />

      {/* Welcome Section */}
{/*       <div className="row mb-4">
        <div className="col-12">
          <div className="card tse-welcome-bg border-0">
            <div className="card-body p-4">
              <div className="row align-items-center">
                <div className="col-lg-8">
                  <h2 className="h4 text-tse-primary mb-2">
                    <i className="bi bi-lightning-charge me-2"></i>
                    Welcome to TriServe Energy
                  </h2>
                  <p className="mb-3">
                    Manage customer accounts, process service requests, and track energy solutions 
                    for our growing network of residential and commercial customers.
                  </p>
                  <div className="d-flex flex-wrap gap-2">
                    <span className="badge bg-success me-2">
                      <i className="bi bi-check-circle me-1"></i>System Online
                    </span>
                    <span className="badge bg-info me-2">
                      <i className="bi bi-graph-up me-1"></i>High Performance
                    </span>
                    <span className="badge bg-warning">
                      <i className="bi bi-exclamation-triangle me-1"></i>2 Active Outages
                    </span>
                  </div>
                </div>
                <div className="col-lg-4 text-end">
                  <i className="bi bi-lightning-charge display-1 text-tse-green opacity-25"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Quick Actions */}
      <div className="row mb-4 dashboard-section">
        <div className="col-12">
          <div className="dashboard-section__header">
            <div className="dashboard-section__eyebrow">Operations</div>
            <h3 className="h5 fw-bold mb-1">Quick Actions</h3>
            <p className="text-muted mb-0 dashboard-section__copy">Jump directly into the most common customer-service workflows.</p>
          </div>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
          <Link to="/new-customer" className="text-decoration-none">
            <div className="card h-100 border-0 shadow-sm dashboard-action-card dashboard-action-card--primary">
              <div className="card-body text-center py-4 dashboard-action-card__body">
                <div className="mb-3 dashboard-action-card__icon-wrap">
                  <i className="bi bi-person-plus display-4 text-tse-primary dashboard-new-customer-icon"></i>
                </div>
                <h5 className="card-title text-tse-primary dashboard-new-customer-title">New Customer</h5>
                <p className="card-text text-muted small mb-0 dashboard-action-card__copy">
                  Register a new customer account and schedule service connection
                </p>
              </div>
            </div>
          </Link>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
          <Link to="/billing" className="text-decoration-none">
            <div className="card h-100 border-0 shadow-sm dashboard-action-card dashboard-action-card--success">
              <div className="card-body text-center py-4 dashboard-action-card__body">
                <div className="mb-3 dashboard-action-card__icon-wrap">
                  <i className="bi bi-credit-card display-4 text-tse-green"></i>
                </div>
                <h5 className="card-title text-tse-green">Bill Payments</h5>
                <p className="card-text text-muted small mb-0 dashboard-action-card__copy">
                  Process customer payments and manage billing accounts
                </p>
              </div>
            </div>
          </Link>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
          <Link to="/service-requests" className="text-decoration-none">
            <div className="card h-100 border-0 shadow-sm dashboard-action-card dashboard-action-card--warning">
              <div className="card-body text-center py-4 dashboard-action-card__body">
                <div className="mb-3 dashboard-action-card__icon-wrap">
                  <i className="bi bi-tools display-4 text-warning"></i>
                </div>
                <h5 className="card-title text-warning">Service Requests</h5>
                <p className="card-text text-muted small mb-0 dashboard-action-card__copy">
                  Manage utility service requests and work orders
                </p>
              </div>
            </div>
          </Link>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
          <Link to="/outage-map" className="text-decoration-none">
            <div className="card h-100 border-0 shadow-sm dashboard-action-card dashboard-action-card--danger">
              <div className="card-body text-center py-4 dashboard-action-card__body">
                <div className="mb-3 dashboard-action-card__icon-wrap">
                  <i className="bi bi-exclamation-triangle display-4 text-danger"></i>
                </div>
                <h5 className="card-title text-danger">Outage Map</h5>
                <p className="card-text text-muted small mb-0 dashboard-action-card__copy">
                  View current power outages and restoration status
                </p>
              </div>
            </div>
          </Link>
        </div>
      </div>

      {/* Statistics */}
      <div className="row mb-4 dashboard-section">
        <div className="col-12">
          <div className="dashboard-section__header">
            <div className="dashboard-section__eyebrow">Performance</div>
            <h3 className="h5 fw-bold mb-1">Today's Statistics</h3>
            <p className="text-muted mb-0 dashboard-section__copy">A live snapshot of current customer, energy, and fulfillment activity.</p>
          </div>
        </div>
        <div className="col-xl-3 col-lg-6 mb-3">
          <div className="card border-0 shadow-sm dashboard-stat-card dashboard-stat-card--primary">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="stat-icon bg-tse-primary bg-opacity-10 rounded-circle p-3 me-3">
                  <i className="bi bi-people fs-4 text-tse-primary"></i>
                </div>
                <div>
                  <h6 className="card-title mb-1">Active Customers</h6>
                  <h3 className="card-text text-tse-primary mb-0">12,847</h3>
                  <small className="text-success">
                    <i className="bi bi-arrow-up me-1"></i>2.3% increase
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-lg-6 mb-3">
          <div className="card border-0 shadow-sm dashboard-stat-card dashboard-stat-card--success">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="stat-icon bg-tse-green bg-opacity-10 rounded-circle p-3 me-3">
                  <i className="bi bi-lightning fs-4 text-tse-green"></i>
                </div>
                <div>
                  <h6 className="card-title mb-1">Energy Delivered</h6>
                  <h3 className="card-text text-tse-green mb-0">847 MWh</h3>
                  <small className="text-success">
                    <i className="bi bi-arrow-up me-1"></i>1.8% increase
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-lg-6 mb-3">
          <div className="card border-0 shadow-sm dashboard-stat-card dashboard-stat-card--warning">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="stat-icon bg-warning bg-opacity-10 rounded-circle p-3 me-3">
                  <i className="bi bi-clock-history fs-4 text-warning"></i>
                </div>
                <div>
                  <h6 className="card-title mb-1">Pending Requests</h6>
                  <h3 className="card-text text-warning mb-0">23</h3>
                  <small className="text-muted">
                    <i className="bi bi-dash me-1"></i>No change
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-lg-6 mb-3">
          <div className="card border-0 shadow-sm dashboard-stat-card dashboard-stat-card--success">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="stat-icon bg-success bg-opacity-10 rounded-circle p-3 me-3">
                  <i className="bi bi-check-circle fs-4 text-success"></i>
                </div>
                <div>
                  <h6 className="card-title mb-1">Completed Today</h6>
                  <h3 className="card-text text-success mb-0">67</h3>
                  <small className="text-success">
                    <i className="bi bi-arrow-up me-1"></i>15% increase
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Recent Activity */}
      <div className="row dashboard-section">
        <div className="col-lg-8 mb-4">
          <div className="card border-0 shadow-sm dashboard-panel-card">
            <div className="card-header bg-light border-0">
              <h5 className="card-title mb-0">
                <i className="bi bi-clock-history me-2 text-tse-primary"></i>
                Recent Activity
              </h5>
            </div>
            <div className="card-body p-0">
              <div className="list-group list-group-flush">
                <div className="list-group-item d-flex align-items-center dashboard-activity-item">
                  <div className="flex-shrink-0 me-3">
                    <div className="bg-success bg-opacity-10 rounded-circle p-2">
                      <i className="bi bi-person-plus text-success"></i>
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="mb-1">New customer registered</h6>
                    <p className="mb-1 small text-muted">John Smith - 123 Main St, Charlotte, NC</p>
                    <small className="text-muted">2 minutes ago</small>
                  </div>
                </div>
                <div className="list-group-item d-flex align-items-center dashboard-activity-item">
                  <div className="flex-shrink-0 me-3">
                    <div className="bg-info bg-opacity-10 rounded-circle p-2">
                      <i className="bi bi-credit-card text-info"></i>
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="mb-1">Payment processed</h6>
                    <p className="mb-1 small text-muted">Customer #TSE-123456789 - $127.45</p>
                    <small className="text-muted">5 minutes ago</small>
                  </div>
                </div>
                <div className="list-group-item d-flex align-items-center dashboard-activity-item">
                  <div className="flex-shrink-0 me-3">
                    <div className="bg-warning bg-opacity-10 rounded-circle p-2">
                      <i className="bi bi-tools text-warning"></i>
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="mb-1">Service request created</h6>
                    <p className="mb-1 small text-muted">Meter reading issue - 456 Oak Ave</p>
                    <small className="text-muted">12 minutes ago</small>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-footer bg-light border-0 text-center">
              <a href="#" className="btn btn-outline-tse-primary btn-sm">
                View All Activity
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-4 mb-4">
          <div className="card border-0 shadow-sm dashboard-panel-card">
            <div className="card-header bg-light border-0">
              <h5 className="card-title mb-0">
                <i className="bi bi-exclamation-triangle me-2 text-warning"></i>
                System Alerts
              </h5>
            </div>
            <div className="card-body">
              <div className="alert alert-warning border-0 mb-3 dashboard-alert-card">
                <div className="d-flex align-items-start">
                  <i className="bi bi-exclamation-triangle me-2 mt-1"></i>
                  <div>
                    <h6 className="mb-1">Planned Maintenance</h6>
                    <p className="mb-0 small">System maintenance scheduled for tonight 11 PM - 2 AM EST</p>
                  </div>
                </div>
              </div>
              <div className="alert alert-info border-0 mb-0 dashboard-alert-card">
                <div className="d-flex align-items-start">
                  <i className="bi bi-info-circle me-2 mt-1"></i>
                  <div>
                    <h6 className="mb-1">New Feature</h6>
                    <p className="mb-0 small">Enhanced billing interface now available with improved search</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
